export interface ITerritory {
  territoryId: number;
  name: string;
  stateCode: string;
}

export class Territory implements ITerritory {
  territoryId: number;
  name: string;
  stateCode: string;
}
